import React from 'react'

const SVG = ({
  style = {},
  fill = "#000",
  width = "100%",
  className = "",
  viewBox = "0 0 12 9"
}) => (
  <svg 
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.6585 0.247437C7.24287 -0.116245 6.6111 -0.0741273 6.24742 0.34151C5.88374 0.757146 5.92586 1.38891 6.3415 1.75259L8.33854 3.5H1C0.447715 3.5 0 3.94772 0 4.5C0 5.05228 0.447715 5.5 1 5.5H8.33856L6.34149 7.24744C5.92586 7.61112 5.88374 8.24288 6.24742 8.65852C6.61111 9.07416 7.24287 9.11627 7.65851 8.75259L11.6585 5.25259C11.8755 5.0627 12 4.78837 12 4.50001C12 4.21165 11.8755 3.93732 11.6585 3.74743L7.6585 0.247437Z"
      fill={fill}
    />
  </svg>
);

export default SVG;